export const formatCount = (num: number): string => {
  if (num >= 1_000_000) return `${(num / 1_000_000).toFixed(1).replace(/\.0$/, "")}M`;
  if (num >= 1000) return `${(num / 1000).toFixed(1).replace(/\.0$/, "")}K`;
  return String(num);
};

export const formatHours = (hours: number | null | undefined): string => {
  if (hours == null) return "—";
  if (hours < 1) return `${Math.round(hours * 60)}m`;
  if (hours < 24) return `${hours.toFixed(1).replace(/\.0$/, "")}h`;
  const days = hours / 24;
  return `${days.toFixed(1).replace(/\.0$/, "")}d`;
};

export const formatPercent = (rate: number | null | undefined): string => {
  if (rate == null) return "—";
  return `${(rate * 100).toFixed(1).replace(/\.0$/, "")}%`;
};

export const formatRateDelta = (delta: number | null | undefined): string => {
  if (delta == null || delta === 0) return "";
  const pts = (delta * 100).toFixed(1).replace(/\.0$/, "");
  return delta > 0 ? `↑${pts} pts` : `↓${Math.abs(Number(pts))} pts`;
};

export const formatCountDelta = (delta: number | null | undefined): string => {
  if (delta == null || delta === 0) return "";
  return delta > 0 ? `↑${formatCount(delta)}` : `↓${formatCount(Math.abs(delta))}`;
};

export const getReviewReasonLabel = (item: {
  label?: string;
  category?: string;
  reason?: string;
}): string => item.label ?? item.category ?? item.reason ?? "Unknown";

export const getPeriodDayCount = (from?: string, to?: string): number => {
  if (!from || !to) return 0;
  const start = new Date(from).getTime();
  const end = new Date(to).getTime();
  if (Number.isNaN(start) || Number.isNaN(end)) return 0;
  return Math.max(1, Math.round((end - start) / (1000 * 60 * 60 * 24)) + 1);
};

export const getTimeSeriesDate = (point: { date?: string; bucket?: string; day?: string }): string =>
  point.date ?? point.bucket ?? point.day ?? "";
